<template>
    <div v-if="fact_swapaddcontent">
        <YoutubeModal v-if="value == 'youtube'" @onyoutube="addvalue($event, 'youtube')"></YoutubeModal>
        <Timer v-if="value == 'timer'" @ontimer="addvalue($event, 'timer')"></Timer>
        <UploadVideo v-if="value == 'video'" @onvideo="addvalue($event, 'video')"></UploadVideo>
        <Track v-if="value == 'track' && current_tab=='3'" @ontrack="addvalue($event, 'track')">
        </Track>
        <ImageModal v-if="value == 'image'" :sizeupimage="1" @onimage="addvalue($event, 'image')"></ImageModal>
        <ImageModal v-if="value == 'slideimage'" :key="update" :sizeupimage="30"
            @onimage="addvalue($event, 'slideimage')">
        </ImageModal>
        <AddButton v-if="value == 'addbutton'" @onaddbutton="addvalue($event, 'addbutton')"></AddButton>
        <Form v-if="value == 'form'" @onform="addvalue($event, 'form')"></Form>
        <TextEditor v-if="value == 'message'" @onmessage="addvalue($event, 'message')"></TextEditor>
    </div>
    <div v-if="fact_type == 'footer'" :class="{ 'overlay': livechat }">
        <div class="btnfooter" :class="{ 'is_close_popup_cookie': is_close_popup_cookie }"
            @click="clicksetaddcontent()">
            <a-space>
                <div class="ml-2">
                    <a-select v-model:value="value" @change="handleChange" style="width:100%;" :listHeight="1800">
                        <template #suffixIcon>

                        </template>
                        <a-select-opt-group>
                            <template #label>
                                <div class="text-center">เพิ่ม</div>
                            </template>
                            <a-select-option value="youtube">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/youtube.jpeg" />
                                </div>

                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group>
                            <a-select-option value="video">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/clip.webp" />
                                </div>

                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group>
                            <template #label> </template>
                            <a-select-option value="image">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/images.png" />
                                </div>
                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group>
                            <template #label> </template>
                            <a-select-option value="addbutton">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/btn.png" />
                                </div>
                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group>
                            <template #label> </template>
                            <a-select-option value="slideimage">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/slide.png" />
                                </div>
                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group>
                            <template #label> </template>
                            <a-select-option value="message">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/twiter.png" />
                                </div>
                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group>
                            <template #label> </template>
                            <a-select-option value="form">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/form.jpeg" />
                                </div>
                            </a-select-option>
                        </a-select-opt-group>
                        <a-select-opt-group v-if="current_tab=='3'">
                            <template #label> </template>
                            <a-select-option value="track">
                                <div class="absolute ">
                                    <img class="p-1 left-icon" src="../../../../../assets/icons/btn/track_img.png" />
                                </div>
                            </a-select-option>
                        </a-select-opt-group>
                    </a-select>
                </div>
            </a-space>
        </div>
    </div>
</template>
<script>
import { defineComponent, ref, watch } from "vue";

import YoutubeModal from "./modalAdd/YoutubeModal.vue"
import Timer from "./modalAdd/Timer.vue"
import ImageModal from "./modalAdd/ImageModal.vue"
import Form from "./modalAdd/Form.vue";
import TextEditor from "./modalAdd/TextEditor.vue";
import UploadVideo from "./modalAdd/Upvideo.vue";
import AddButton from "./modalAdd/AddButton.vue";
import Track from "./modalAdd/Track.vue";
import { objsalepage, objsalepagethank, objsalepagethankform, current_tab, value, onEdit, isclickaddcontent, swapaddcontent } from '@/store/store'

export default defineComponent({
    components: { YoutubeModal,Timer, ImageModal, Form, TextEditor, UploadVideo, AddButton, Track },
    props: ['type'],
    setup(props, { emit }) {
        const fact_type = ref(props.type)
        const fact_swapaddcontent = ref(swapaddcontent.value)
        console.log("select_image_footer:", fact_swapaddcontent)
        const update = ref(0);
        const handleChange = value => {
            update.value++
            console.log(`selected ${value}`);
        };
        const options = ref([
            {
                label: "Youtube",
                options: [
                    {
                        value: "youtube",
                        label: "youtube"
                    },
                    {
                        value: "lucy",
                        label: "Lucy"
                    }
                ]
            },
            {
                label: "Engineer",
                options: [
                    {
                        value: "yiminghe",
                        label: "Yiminghe"
                    }
                ]
            }
        ]);
        watch(value, () => {
            // setTimeout(() => {
            //     value.value = ["เลือก"]
            // }, 1000);
        })
        const addvalue = (e, fact) => {
             
            console.log(onEdit.value)
            console.log(objsalepage.value)
            if (onEdit.value.isshowedit) {
                var indexedit = onEdit.value.editobj.order;
                if (current_tab.value == '1') {
                    // objsalepage.value.splice(indexedit - 1, 1);
                    objsalepage.value[indexedit - 1] = { detail: e, order: indexedit };
                    value.value = ["เลือก"]
                }
                else if (current_tab.value == '2') {
                    objsalepagethank.value[indexedit - 1] = { detail: e, order: indexedit };
                    value.value = ["เลือก"]
                }
                else if (current_tab.value == '3') {
                    objsalepagethankform.value[indexedit - 1] = { detail: e, order: indexedit };
                    value.value = ["เลือก"]
                }


            }
            else {
                console.log(fact)
                console.log("objsalepage.value"), objsalepage.value
                console.log("objsalepagethank.value", objsalepagethank.value)

                if (current_tab.value == '1') {
                    objsalepage.value.push({ detail: e, order: objsalepage.value.length + 1 });
                    value.value = ["เลือก"]
                }
                else if (current_tab.value == '2') {
                    objsalepagethank.value.push({ detail: e, order: objsalepagethank.value.length + 1 });
                    value.value = ["เลือก"]
                }
                else if (current_tab.value == '3') {
                    objsalepagethankform.value.push({ detail: e, order: objsalepagethankform.value.length + 1 });
                    value.value = ["เลือก"]
                }

            }

            emit('onobjsalepage', objsalepage)
            console.log(e);
            onEdit.value.isshowedit = false
        };



        const livechat = ref(false);
        const fadeout = ref(false);
        const fadebottom = ref(false);
        function clickchat() {
            if (livechat.value) {
                fadebottom.value = !fadebottom.value
                fadeout.value = !fadeout.value
                setTimeout(() => {
                    livechat.value = !livechat.value
                    fadeout.value = !fadeout.value
                }, 400);
            }
            else {
                fadebottom.value = !fadebottom.value
                livechat.value = !livechat.value
            }

        }

        function clickbtn(message) {
            console.log(message)
        }
        function clicksetaddcontent() {

            swapaddcontent.value = true;
            fact_swapaddcontent.value = swapaddcontent.value
            console.log("select_image_footer:", fact_swapaddcontent.value)
        }

        return {
            value,
            handleChange,
            options,
            objsalepage,
            addvalue,
            onEdit,
            update, clickchat, clickbtn, livechat,
            fact_type,
            isclickaddcontent,
            fact_swapaddcontent,
            clicksetaddcontent,
            current_tab
        };
    }
});
</script>
<style lang="scss">
.text-i60 {
    text-indent: 20px;
}




.text-chat {
    left: auto;
    position: relative;
    text-align: right;
}

.text-chat-bottom {
    left: -210%;
    position: relative;
    text-align: left;
    top: 15px;
    width: 200px;

}

.text-inner {
    background: #d3d3d3;
    color: black;
    border-radius: 5px;
    padding: 5px;
    word-break: break-word;
}

.fade-out {
    text-decoration: none;
    position: relative;
    animation: fadeOut 0.4s;
    left: 20px !important;
}

@keyframes fadeOut {
    from {
        bottom: 0;
        opacity: 1
    }

    to {
        bottom: -300px;
        opacity: 0
    }
}

.fade-bottom {
    position: relative;
    animation: animatebottom 0.4s;
    left: 20px;
    max-width: 100px;

}

@keyframes animatebottom {
    from {
        bottom: -300px;
        opacity: 0
    }

    to {
        bottom: 0;
        opacity: 1
    }
}

.c-chat {
    /* background-color: rgb(247, 129, 27); */
    transition: all 0.3s ease 0s;
    cursor: pointer;
    color: #fff;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: inline-block;
    text-decoration: none;
    float: right;
    position: relative;
}

.ic-bottom {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.is_close_popup_cookie {
    bottom: 12% !important;
}

.animate-bounce {
    display: inherit;
}

a {
    text-decoration: unset !important;
}


.btnfooter {
    background: url('../../../../../assets/imgs/logo/add_green.png');
    background-repeat: no-repeat;
    position: absolute;
    min-height: 79px;
    background-size: contain;
    width: 35%;
    right: 33%;
}




@media only screen and (max-width: 390px) {
    .btnfooter {
        background: url('../../../../../assets/imgs/logo/add_green.png');
        background-repeat: no-repeat;
        position: absolute;
        min-height: 79px;
        background-size: contain;
        width: 35px;
        right: 23%;
    }

}

.btnfooter {
    .ant-select-selector {
        height: 50px !important;
        border: 0px;
        color: transparent;
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        left: -15px;
        top: -2px;
    }

    .ant-select-selection-item {
        color: transparent !important;
    }
}

.rc-virtual-list-holder-inner {
    padding-bottom: 20px;
}

.left-icon {
    margin-left: -10px;
    width: 40px;
}

.left-icon:hover {
    transform: scale(2);
}
</style>
